//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { GenericModal } from "@Shared/components/modals";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ConfirmDeleteContactsModal",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {
    deletingAllContacts: {
      type: Object,
      required: true
    }
  },
  methods: {
    showModal() {
      this.$showModal();
    },
    hideModal() {
      this.$hideModal();
    },
    handleConfirm() {
      this.hideModal();
      this.$emit("confirm");
    },
    handleDismiss() {
      this.hideModal();
    }
  }
});